<template lang="pug">
.l-map-renderer(
  :style="styleObject"
)
  slot
</template>

<style lang="stylus" scoped>
@import '~@/assets/styles/foundation/_variables.styl'

.l-map-renderer
  pos()
  wh(100vw,100vh)
  transition transform 750ms $easeOutExpo
  
  
</style>


<script>
import { defineComponent,onMounted,computed } from "vue"
import { useRoute, useRouter } from 'vue-router'
import { useStore } from '@/store'

export default defineComponent({
  name:'MapRenderer',

  setup(props, context) {
    const router = useRouter()
    const route = useRoute()
    const store = useStore()
    onMounted(()=>{
    })
    const styleObject = computed(()=>{
      if(store.browser.state.responsive == 'pc' && store.ui.state.article.show){
        if(route.params.id){
          const spots = store.api.state.spotsSearchById(route.params.id)
          if(spots){
            const coordinate = store.api.state.spotsSearchById(route.params.id).coordinate.split(",")
            const coordinateX = Number(coordinate[0])
            const coordinateY = Number(coordinate[1])
            const globalXY = store.ui.state.getMapSceneCameraGLobalXY(coordinateX,coordinateY)
            const articleWidth = 550
            const targetX = (store.browser.state.windowWidth - articleWidth) >> 1
            const windowGlobalX = store.browser.state.windowWidthHalf + globalXY.x
            const x = targetX - windowGlobalX
            return {
                transform:'translate('+x+'px,0px)',
                height:store.browser.state.windowHeight + 'px'
            }
          }
        }
      }
      return {
        // transform:''
      }
    })
    return{
      styleObject
    }
  }
})
</script>
